module.exports = {
  'brand-success': '#40BF60',
  'brand-error'  : '#F65663',
  'brand-info'   : '#4299F0',
  'brand-warning': '#F2A65A',

  'brand-veryHigh': '#f4c32c',
  'brand-high'    : '#f7d261',
  'brand-target'  : '#1ea98c',
  'brand-tight'   : '#167d67',
  'brand-low'     : '#f9707e',
  'brand-veryLow' : '#f74053',
};

/*
  New palette
  'brand-veryHigh': '#FABB00',
  'brand-high'    : '#F5D400',
  'brand-target'  : '#1A9927',
  'brand-tight'   : '#106218',
  'brand-low'     : '#BA282E',
  'brand-veryLow' : '#8E0B0F',
   */
